/** Light theme is `true` (same convention as themeSelector). */
export const themeScrollbarCss = (selector: string, light: boolean) => {
  const thumb = light ? 'rgba(100, 116, 139, 0.5)' : 'rgba(148, 163, 184, 0.42)';
  const thumbHover = light ? 'rgba(71, 85, 105, 0.72)' : 'rgba(203, 213, 225, 0.62)';
  const track = light ? 'rgba(226, 232, 240, 0.85)' : 'rgba(51, 65, 85, 0.65)';

  const targets = selector.split(',').map((part) => part.trim()).filter(Boolean);
  const rule = (suffix: string, body: string) =>
    targets.map((target) => `${target}${suffix} { ${body} }`).join('\n');

  return `
    ${rule('', `scrollbar-width: thin; scrollbar-color: ${thumb} ${track};`)}
    ${rule('::-webkit-scrollbar', 'width: 10px; height: 10px;')}
    ${rule('::-webkit-scrollbar-track', `background: ${track}; border-radius: 999px;`)}
    ${rule('::-webkit-scrollbar-thumb', `background: ${thumb}; border-radius: 999px; border: 2px solid transparent; background-clip: padding-box;`)}
    ${rule('::-webkit-scrollbar-thumb:hover', `background: ${thumbHover};`)}
    ${rule('::-webkit-scrollbar-corner', 'background: transparent;')}
  `;
};
